import { Instagram, Facebook, MessageCircle, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a9cc0a93-1f4d-4a5a-adee-0b6b5c9eedbf/artifacts/fb6ipjk0_Prancheta%2038.png";

const SOCIALS = [
  { icon: Instagram, href: "https://www.instagram.com/aminefestas", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61557509742561", label: "Facebook" },
  { icon: MessageCircle, href: "https://wa.me/556193761185", label: "WhatsApp" },
];

const MAPS_LINK = "https://share.google/uZeGpdMSnkFJ2Nav3";

export default function Footer() {

  return (
    <footer data-testid="footer-section" className="bg-[#1a1a1a] pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <img
              src={LOGO_URL}
              alt="Amine Festas"
              className="h-[4.5rem] md:h-14 logo-invert mb-4"
            />
            <p className="text-white/50 text-sm leading-relaxed">
              Decoração de festas personalizadas e temáticas em Brasília. Transformamos sonhos em celebrações.
            </p>
          </div>

          {/* Links */}
          <div>
            <h3 className="text-white text-sm font-medium mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
              Navegação
            </h3>
            <nav className="flex flex-col gap-2">
              <a href="#sobre" className="text-white/50 text-sm hover:text-[#E4077B] transition-colors">Sobre</a>
              <a href="#servicos" className="text-white/50 text-sm hover:text-[#E4077B] transition-colors">Serviços</a>
              <a href="#galeria" className="text-white/50 text-sm hover:text-[#E4077B] transition-colors">Galeria</a>
              <a href="#depoimentos" className="text-white/50 text-sm hover:text-[#E4077B] transition-colors">Depoimentos</a>
              <Link to="/servicos" className="text-white/50 text-sm hover:text-[#E4077B] transition-colors">Blog</Link>
            </nav>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-white text-sm font-medium mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
              Contato
            </h3>
            <div className="flex flex-col gap-3">
              <a
                href="https://wa.me/556193761185"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/50 text-sm hover:text-[#E4077B] transition-colors"
                data-testid="footer-whatsapp-number"
              >
                <Phone size={14} />
                +55 (61) 9376-1185
              </a>
              <a
                href="mailto:contato@aminefestas.com.br"
                className="flex items-center gap-2 text-white/50 text-sm hover:text-[#E4077B] transition-colors"
                data-testid="footer-email"
              >
                <Mail size={14} />
                contato@aminefestas.com.br
              </a>
              <a
                href={MAPS_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/50 text-sm hover:text-[#E4077B] transition-colors"
                data-testid="footer-location"
              >
                <MapPin size={14} />
                Brasília - DF
              </a>
            </div>
          </div>

          {/* Redes Sociais */}
          <div>
            <h3 className="text-white text-sm font-medium mb-4" style={{ fontFamily: "Outfit, sans-serif" }}>
              Redes Sociais
            </h3>
            <div className="flex gap-3">
              {SOCIALS.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-${label.toLowerCase()}-link`}
                  className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white/60 hover:bg-[#E4077B] hover:text-white transition-all duration-300"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex items-center justify-center">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()} Amine Festas. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
